export default __webpack_public_path__ + "static/media/alphabet_gray.9a1a0048.svg";